import { Fetch } from 'lib';
import type { CatalogSortType, CatalogSummary } from 'types';

type RequestResponses = {
  total: number;
  data: CatalogSummary[];
};

type RequestParameters = {
  sortType: CatalogSortType;
  searchKey: string;
  pageSize: number;
  pageNumber: number;
};

const searchCatalogs = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminCatalog/searchCatalogs',
    params,
  });

export { searchCatalogs };
